package pl.michal_cyran.brand_hub.subpages.freelancing

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowRight
import com.varabyte.kobweb.silk.components.icons.fa.FaGooglePlay
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.HeroContainerStyle
import pl.michal_cyran.brand_hub.DarkSectionStyle
import pl.michal_cyran.brand_hub.components.widgets.FeaturedButton
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUp
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUpScale
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun FreelancingFinalCTA() {
    val cm = ColorMode.current.toSitePalette()

    Column(
        DarkSectionStyle.toModifier().fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Box(
            HeroContainerStyle
                .toModifier()
                .maxWidth(1280.px)
        ) {
            VisibilityAware(
                modifier = Modifier
                    .fillMaxWidth()
                    .backgroundColor(cm.cardFeaturedBg)
                    .padding(leftRight = 2.cssRem, topBottom = 4.cssRem)
                    .borderRadius(3.cssRem)
                    .color(cm.textOnPrimary)
            ) { isVisible ->
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .backgroundColor(cm.cardFeaturedBg)
                        .padding(leftRight = 2.cssRem, topBottom = 4.cssRem)
                        .borderRadius(3.cssRem)
                        .color(cm.textOnPrimary)
                        .revealFadeSlideUpScale(
                            isVisible,
                            delayMs = 0,
                            distance = 20.px,
                            fromScale = 0.96
                        ),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    H1(
                        Modifier
                            .revealFadeSlideUp(isVisible, delayMs = 150)
                            .toAttrs()
                    ) {
                        Text(
                            " Każdy projekt to nowa historia sukcesu."
                        )
                    }

                    P(
                        Modifier
                            .color(cm.textOnPrimaryDim)
                            .revealFadeSlideUp(isVisible, delayMs = 250)
                            .toAttrs()
                    ) {
                        Text(
                            " Odkryj moje dotychczasowe realizacje. Zobacz jak Kotlin Multiplatform zmienia sposób, w jaki firmy budują oprogramowanie."
                        )
                    }

                    Box(
                        modifier = Modifier
                            .revealFadeSlideUp(isVisible, delayMs = 350)
                    ) {
                        FeaturedButton(
                            path = "https://lightios.github.io/projects",
                            text = "Zobacz moje portfolio",
                            icon = { FaArrowRight() },
                        )
                    }
                }
            }

        }
    }
}